@if (column && column.filterType > 0) {
    <div
        id="{{ column.table.key + column.field + 'Filter' }}"
        [ngClass]="{ 'is-outside-table': isOutsideTable }"
        (click)="stop($event)"
    >
        @if (column.filterType !== 6 && !isOutsideTable) {
            <app-svg-icon
                id="{{ column.table.key + column.field + 'FilterIcon' }}"
                (click)="toggleExpanded($event)"
                icon="filter"
            >
            </app-svg-icon>
        }
        @if (column.filterType === 1) {
            <div class="m-column-search">
                <input
                    id="{{ column.table.key + column.field + 'FilterInput' }}"
                    #textInput
                    [(ngModel)]="currentFilter"
                    [debounceTime]="400"
                    (appDebounce)="filter($event, 'contains')"
                    (blur)="expanded = false"
                    (focus)="expanded = true"
                    (keydown)="validateKeypress($event)"
                    (keyup)="$event.stop()"
                    pInputText
                    placeholder="{{ column.header | translate }}"
                    type="text"
                />
            </div>
        }
        @if (column.filterType === 2 && expanded) {
            <div
                class="m-column-slider"
                [ngStyle]="expanded ? { display: 'block' } : {}"
            >
                <div class="m-slider-label">
                    <input
                        class="hide-spinner"
                        id="{{ column.table.key + column.field + 'FilterSliderInput' }}"
                        [debounceTime]="400"
                        [ngModel]="currentFilter"
                        (appDebounce)="filterNumber($event)"
                        (click)="stop($event)"
                        placeholder="{{ column.header | translate }}"
                        type="number"
                    />
                    @if (currentFilter) {
                        <app-svg-icon
                            id="{{ column.field + 'ClearFilter' }}"
                            [ngStyle]="{ cursor: 'pointer' }"
                            (click)="clearFilter()"
                            icon="close"
                        >
                        </app-svg-icon>
                    }
                </div>
                <p-slider
                    id="{{ column.table.key + column.field + 'FilterSlider' }}"
                    [(ngModel)]="currentFilter"
                    [debounceTime]="400"
                    [max]="column.filterMax || 100000"
                    [min]="column.filterMin || 0"
                    [step]="column.step || 1"
                    (appDebounce)="filterNumber($event)"
                >
                </p-slider>
            </div>
        }
        @if (column.filterType === 3) {
            <p-date-picker
                class="m-column-calendar"
                id="{{ column.table.key + column.field + 'FilterCalendar' }}"
                [(ngModel)]="currentFilter"
                [dateFormat]="column.table.calendarSettings.dateFormat"
                [hourFormat]="column.table.calendarSettings.hourFormat"
                [selectionMode]="column.filterMatchMode === 'inside' ? 'range' : 'single'"
                [showIcon]="true"
                (click)="stop($event)"
                (onClearClick)="clearFilter()"
                (onSelect)="filterDate(currentFilter)"
                appendTo="body"
                autoWidth="false"
                placeholder="{{ column.header | translate }}"
                readonlyInput="true"
                showButtonBar="true"
            >
            </p-date-picker>
        }
        @if (column.filterType === 4 && column.filterOptions) {
            <p-select
                class="m-column-dropdown"
                id="{{ column.table.key + column.field + 'FilterDropdown' }}"
                [(ngModel)]="currentFilter"
                [filter]="column.displayDropdownFilter"
                [options]="column.filterOptions"
                [showClear]="isOutsideTable"
                [style]="{ width: '100%' }"
                (click)="toggleExpanded(); stop($event)"
                (onChange)="filter($event.value, 'equals')"
                (onHide)="close()"
                appendTo="body"
                placeholder="{{ column.header | translate }}"
            >
            </p-select>
        }
        @if (column.filterType === 5 && column.filterOptions) {
            <p-multiSelect
                class="m-column-multiselect"
                id="{{ column.table.key + column.field + 'FilterMultiSelect' }}"
                [(ngModel)]="currentFilter"
                [filter]="column.displayDropdownFilter"
                [options]="column.filterOptions"
                [showHeader]="column.displayDropdownFilter"
                [showToggleAll]="false"
                (click)="closeIfTargetIsNotListItem($event)"
                (onChange)="filter($event.value, 'in')"
                (onPanelHide)="close()"
                (onPanelShow)="open()"
                appendTo="body"
                placeholder="{{ column.header | translate }}"
            >
            </p-multiSelect>
        }
        @if (column.filterType === 6 && column.type === 5) {
            <p-checkbox
                [(ngModel)]="currentFilter"
                [binary]="true"
                [id]="column.table.key + column.field + 'FilterCheckbox'"
                [indeterminate]="currentFilter === null"
                [name]="isOutsideTable ? (column.header | translate) : ''"
                (click)="stop($event); handleThreeStateChange($event)"
            />
        }
        @if (column.filterType === 6 && column.type === 6) {
            <p-checkbox
                id="{{ column.table.key + column.field + 'FilterCheckbox' }}"
                [(ngModel)]="currentFilter"
                [binary]="true"
                [name]="isOutsideTable ? (column.header | translate) : ''"
                (click)="stop($event)"
                (onChange)="filterBoolean($event.checked)"
                name="{{ column.table.key + column.field + 'FilterCheckbox' }}"
            ></p-checkbox>
        }
    </div>
}
